import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.API_BASE_URL,
});

api.interceptors.request.use(async (reqConfig) => {
  // Default X-Location-Id to the user's currently-selected wash, BUT let a
  // per-request override win. That's how the "import SOPs from another wash"
  // flow reaches a non-current location without switching the user's context.
  const locationId = localStorage.getItem('currentLocationId');
  if (locationId && !reqConfig.headers['X-Location-Id']) {
    reqConfig.headers['X-Location-Id'] = locationId;
  }

  // Add Firebase auth token
  const token = localStorage.getItem('firebase_token');
  if (token && !reqConfig.headers['Authorization']) {
    reqConfig.headers['Authorization'] = `Bearer ${token}`;
  }

  return reqConfig;
});

export default api;
